import React from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

// Horizontal scroll-snap gallery of cinematic posters (2:3).
const HorizontalGallery = ({ items }) => {
  const { t, lp } = useLang();
  return (
    <div className="flex gap-6 overflow-x-auto no-scrollbar snap-x snap-mandatory px-6 md:px-12 pb-4" data-testid="horizontal-gallery">
      {items.map((item) => (
        <Link
          key={item.slug}
          to={lp(`/proyectos/${item.slug}`)}
          data-testid={`gallery-poster-${item.slug}`}
          className="group relative shrink-0 snap-start w-[75vw] sm:w-[46vw] lg:w-[30vw] aspect-[2/3] rounded-2xl overflow-hidden border border-white/10"
        >
          <img
            src={item.image}
            alt={item.title}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
          {item.vimeo && (
            <div className="absolute top-5 right-5 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 backdrop-blur border border-white/25 group-hover:bg-brand-gold group-hover:text-ink transition-colors">
              <Play size={18} className="ml-0.5" />
            </div>
          )}
          <div className="absolute bottom-0 inset-x-0 p-7">
            <span className="font-display text-[0.65rem] font-bold uppercase tracking-[0.25em] text-brand-gold">
              {t(item.format || item.kicker)}
            </span>
            <h3 className="mt-2 font-display text-2xl md:text-3xl font-black uppercase text-white leading-none">{item.title}</h3>
            {item.year && <p className="mt-2 font-display text-xs font-bold text-white/50">{item.year}</p>}
          </div>
        </Link>
      ))}
    </div>
  );
};

export default HorizontalGallery;
